import { BEST_OF_WOLT_NAVIGATION_ITEM } from '../constants';
import { NavigationItem } from '../types';

export const useVenueNavigationItems = (): NavigationItem[] => {
  // Best Of Wolt
  const shouldShowBestOfWoltNavigation = true; // TODO: Implement logic to determine if best of wolt navigation should be shown

  return [...(shouldShowBestOfWoltNavigation ? [BEST_OF_WOLT_NAVIGATION_ITEM] : [])];
};
